import {
  Component,
  inject,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { HeaderComponent } from '../../header/header.component';
import { TuiButton, TuiSurface } from '@taiga-ui/core';
import { TuiCardLarge, TuiHeader } from '@taiga-ui/layout';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TuiInputModule, TuiTextfieldControllerModule } from '@taiga-ui/legacy';
import { PrescriptionFormListComponent } from '../prescription-form-list/prescription-form-list.component';

@Component({
  selector: 'app-prescription-form-list-page',
  standalone: true,
  imports: [
    HeaderComponent,
    TuiSurface,
    TuiHeader,
    TuiCardLarge,
    TuiButton,
    ReactiveFormsModule,
    TuiInputModule,
    TuiTextfieldControllerModule,
    PrescriptionFormListComponent,
  ],
  templateUrl: './prescription-form-list-page.component.html',
  styleUrl: './prescription-form-list-page.component.scss',
})
export class PrescriptionFormListPageComponent implements OnInit {
  private readonly formBuilder = inject(FormBuilder);

  nomPrenom0: WritableSignal<string | undefined> = signal(undefined);
  nir0: WritableSignal<string | undefined> = signal(undefined);

  searchForm!: FormGroup;

  onSubmitForm(): void {
    if (this.searchForm.valid) {
      this.nomPrenom0.set(this.searchForm.value.nomPrenom);
      this.nir0.set(this.searchForm.value.nir);
    }
  }

  ngOnInit(): void {
    this.searchForm = this.formBuilder.group({
      nomPrenom: [''],
      nir: [''],
    });
  }
}
